var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './InfoSection.module.scss';
export var InfoSection = function (props) {
    var info = props.info;
    return (_jsx("div", __assign({ className: styles.infoSection }, { children: info.map(function (item, index) {
            return item.map(function (infoItem, infoIndex) {
                var label = infoItem.label;
                var isLabelValidString = typeof label === 'string' && label.length;
                return (_jsxs("div", __assign({ className: styles.infoSectionCell, style: {
                        gridColumn: "".concat(infoIndex + 1, " / 2"),
                        gridRow: index + 1,
                    } }, { children: [label && _jsx("p", __assign({ className: styles.labelInfoCell }, { children: label })), _jsx("p", __assign({ className: styles.valueInfoCell }, { children: infoItem.value }))] }), isLabelValidString ? infoItem.label : "".concat(index, " ").concat(infoIndex)));
            });
        }) })));
};
